import type { Modal } from 'hooks/useGlobalModal';

export const downloadAppleWalletPassErrorModalProps: Modal = {
  variant: 'error',
  header: 'Download failed',
  body: (
    <>
      An error occurred while downloading the Apple Wallet pass. Please check your browser settings for download permissions and try again.
    </>
  ),
};
